// extracted by mini-css-extract-plugin
module.exports = {"mobileCopyNotification":"CopyNotification_mobileCopyNotification__zZEZ8","mobileCopyNotificationContent":"CopyNotification_mobileCopyNotificationContent__QLgg6"};